export const DialerTestIds = {
  NUMBER: 'telephony-dialer.number-input',
  CALL: 'telephony-dialer.call-button',
  DELETE: 'telephony-dialer.delete-button',
};
